"use client"

import { CornerUpRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CornerUpRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CornerUpRightIcon = component(Icon)({ as: CornerUpRight })
